export const asyncComponentsUrl = import.meta.env.VITE_ASYNC_COMPONENTS_URL;
export const stylesUrl = import.meta.env.DEV ? asyncComponentsUrl.replace(/^\.\.\//, '') : asyncComponentsUrl;

let hashCache: Record<string, string> | null = null;
export const getHashMap = async () => {
    if (hashCache) return hashCache;
    const { default: hashMaps } = await import(/* @vite-ignore */ `${asyncComponentsUrl}hash-map.js`);
    hashCache = hashMaps;
    return hashMaps;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const cache = new Map<string, any>();
export const getDynamicImport = async (key: string) => {
    if (cache.has(key)) {
        return cache.get(key);
    }
    const hashMaps = await getHashMap();
    const hashedFileName = hashMaps[key];
    // isDev to fix a small quirk with loading css and js in local, since css cannot be imported in prod as done here.
    // see `Import the built css for the cdn components` in main.ts
    const result = await import(/* @vite-ignore */ `${asyncComponentsUrl}${hashedFileName}`);
    cache.set(key, result);
    return result;
};